import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img
          src="/uploads/hero.jpg"
          alt="A vibrant view of the DMV area showcasing its landmarks and community"
          className="hero-image"
        />
        <p className="eyebrow">DMV Live News</p>
        <h1>Your Source for the Latest DMV News</h1>
        <p className="lede">
          Stay informed about breaking news, local events, and essential updates in the D.C., Maryland, and Virginia areas.
        </p>
        <div className="cta-row">
          <a href="#latest-news" className="primary">
            Read the Latest
          </a>
        </div>
      </header>

      <section className="cards" id="latest-news">
        <article>
          <h2>DMV housing market shifts toward buyers in 2026</h2>
          <p>Growing inventory and stabilizing mortgage rates are giving DMV buyers more leverage this year, with new listings up 7.1% year-over-year as of April.</p>
        </article>
        <article>
          <h2>Federal spending debates dominate DC politics</h2>
          <p>Lawmakers continue negotiating government funding priorities -- infrastructure, healthcare subsidies, and national security spending -- keeping Washington politics front and center.</p>
        </article>
      </section>

      <section className="cards">
        <article>
          <h2>Breaking News</h2>
          <p>
            Get real-time updates on the most important stories affecting the DMV area.
          </p>
        </article>
        <article>
          <h2>Local Events</h2>
          <p>
            Discover upcoming events and activities happening in your community.
          </p>
        </article>
        <article>
          <h2>Traffic Updates</h2>
          <p>
            Stay ahead of the road conditions with our timely traffic reports.
          </p>
        </article>
        <article>
          <h2>Weather Forecasts</h2>
          <p>
            Plan your day with accurate weather forecasts tailored for the DMV region.
          </p>
        </article>
        <article>
          <h2>Community Features</h2>
          <p>
            Explore stories that highlight the people and places that make the DMV unique.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;